import userMemberApi from '@/api/usermember'
import userApi from '@/api/user'
import org from '@/api/organization'
import { organization as OrganizationModel } from '@/api/models'
import { mergeUserContext } from '@/store/helpers'
const organizationTypesData = require('./data/organizationTypes.json')
const organizationTypesDataLA = require('./data/organizationTypesLA.json')

organizationTypesData.items.sort((a, b) => {
  if (a.text === 'Other') {
    return 1
  }
  return a.text < b.text ? -1 : 1
})

// initial state
const state = {
  allOrganizations: [],
  allOrganizationTypes: organizationTypesData.items,
  allOrganizationTypesLA: organizationTypesDataLA.items,
  userLicenseAuth: 0,
  userLicensedUsed: 0,

  createOrganization: Object.assign({}, OrganizationModel),
  createOrganizationPending: false,
  createOrganizationFailure: false,
  recentlyCreatedOrganization: false,

  organizationLocations: [],
  organizationPrograms: [],
  ViewOrganization: Object.assign({}, OrganizationModel),

  editOrganization: Object.assign({}, OrganizationModel),
  updateOrganizationPending: false,
  updateOrganizationFailure: false,
  updateOrganizationSuccess: false,

  allUserList: [],

  orgMembers: [],
  orgCreateMemPending: false,
  orgCreateMemSuccess: false,
  orgCreateMemFailure: false,

  orgUpdateMemPending: false,
  orgUpdateMemSuccess: false,
  orgUpdateMemFailure: false,

  orgLocations: [],
  orgPrograms: [],
  orgGroups: []
}

// getters
const getters = {

  getAllOrganizations: state => state.allOrganizations,
  getAllOrganizationTypes: state => state.allOrganizationTypes,
  getAllOrganizationTypesLA: state => state.allOrganizationTypesLA,
  getCreateOrganization: state => state.createOrganization,

  getCreateOrganizationPending: state => state.createOrganizationPending,
  getCreateOrganizationFailure: state => state.createOrganizationFailure,

  getOrganizationLocations: state => state.organizationLocations,
  getOrganizationPrograms: state => state.organizationPrograms,
  getRecentlyCreatedOrganization: state => state.recentlyCreatedOrganization,
  getViewOrganization: state => state.ViewOrganization,

  getEditOrganization: state => state.editOrganization,
  getUpdateOrganizationPending: state => state.updateOrganizationPending,
  getUpdateOrganizationFailure: state => state.updateOrganizationFailure,
  getUpdateOrganizationSuccess: state => state.updateOrganizationSuccess,

  getAllUserList: state => state.allUserList,
  getUserLicenseAuth: state => state.userLicenseAuth,
  getUserLicenseUsed: state => state.userLicenseUsed,
  getOrgMembers: state => state.orgMembers,

  getOrgCreateMemPending: state => state.orgCreateMemPending,
  getOrgCreateMemSuccess: state => state.orgCreateMemSuccess,
  getOrgCreateMemFailure: state => state.orgCreateMemFailure,

  getOrgUpdateMemPending: state => state.orgUpdateMemPending,
  getOrgUpdateMemSuccess: state => state.orgUpdateMemSuccess,
  getOrgUpdateMemFailure: state => state.orgUpdateMemFailure,

  getLocationsByOrg: state => state.orgLocations,
  getProgramsByOrg: state => state.orgPrograms,
  getGroupsByOrg: (state) => state.orgGroups
}

// actions
const actions = {
  async userLicenseAuth ({ commit, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)
    let response = await userMemberApi.getLicenseAuth(payload)
    if (response.status !== 200) {
      console.log('Error getting getuserLicenseAuth', response)
      return
    }
    commit('setUserLicenseAuth', response.body)
  },

  async userLicenseUsed ({ commit, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)
    let response = await userMemberApi.getLicenseUsed(payload)
    if (response.status !== 200) {
      console.log('Error getting getuserLicenseUsed', response)
      return
    }
    commit('setUserLicenseUsed', response.body)
  },
  async getUserList ({ commit, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)
    let response = await userApi.getUserForLists(payload)
    if (response.status !== 200) {
      console.log('Error getting getUserList', response)
      return
    }
    commit('setUsersList', response.body)
  },

  async getOrgUserMemberships ({ commit }, payload) {
    let response = await org.getOrgMemberships(payload)
    if (response.status !== 200) {
      console.log('Error getting getOrgUserMemberships', response)
      return
    }
    commit('setOrgMember', response.body)
  },

  async createOrgUserMembership ({ commit }, payload) {
    console.log('createOrgUserMembership')
    console.log(payload)
    commit('setOrgCreateMemPending', true)
    if (payload.isDWUser === true) {
      console.log('isDWUser ==== true')
      let dwUserCheck = await userMemberApi.getLicenseUsed(payload)
      if (dwUserCheck.status && dwUserCheck.status !== 200) {
        console.log('dwUser check failed on create')
        console.log(dwUserCheck)
        commit('setOrgCreateMemPending', false)
        commit('setOrgCreateMemFailure', 'All data warehouse seats allocated')
        return
      }
    }
    var response = await userMemberApi.createUserMembership(payload)
    commit('setOrgCreateMemPending', false)
    if (response.status !== 200) {
      console.log('error from create org mem API >>', response)
      if (response.body) {
        commit('setOrgCreateMemFailure', response.body)
      } else {
        commit('setOrgCreateMemFailure', 'Error while creating membership')
      }
      return
    }
    commit('setOrgCreateMemSuccess', response.data)
  },

  async deleteOrgUserMembership ({ commit }, payload) {
    commit('setOrgUpdateMemPending', true)
    var response = await userMemberApi.deleteUserMembership(payload)
    commit('setOrgUpdateMemPending', false)
    if (response.status !== 200) {
      console.log('error from delete org mem API >>', response)
      if (response.body.details) {
        commit('setOrgUpdateMemFailure', response.body.details)
      } else {
        commit('setOrgUpdateMemFailure', response.body.message)
      }
      return
    }
    commit('setOrgDeleteMemSuccess', response.data)
  },

  async updateOrgUserMembership ({ commit }, payload) {
    console.log('updateOrgUserMembership')
    console.log(payload)
    commit('setOrgUpdateMemPending', true)
    if (payload.data.isDWUser === true) {
      console.log('data.isDWUser ==== true')
      let dwUserCheck = await userMemberApi.getLicenseUsed(payload)
      if (dwUserCheck.status && dwUserCheck.status !== 200) {
        console.log('dwUser check failed on update')
        console.log(dwUserCheck)
        commit('setOrgUpdateMemPending', false)
        commit('setOrgUpdateMemFailure', 'All data warehouse seats allocated')
        return
      }
    }
    var response = await userMemberApi.updateUserMembership(payload)
    commit('setOrgUpdateMemPending', false)
    if (response.status !== 200) {
      console.log('error from delete org mem API >>', response)
      if (response.body.details) {
        commit('setOrgUpdateMemFailure', response.body.details)
      } else {
        commit('setOrgUpdateMemFailure', response.body.message)
      }
      return
    }
    commit('setOrgUpdateMemSuccess', response.data)
  },
  // #region Ogranization CRUD

  async getOrganizations ({ commit, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)
    let response = await org.getOrganizations(payload)
    if (response.body) {
      response = response.body
      response = response.filter((org) => !org.isRemoved)
      commit('setAllOrganizations', response)
    }
    return response
  },

  async getOrganizationLocations ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)

    let response = await org.getOrganizationLocations(payload)
    response = response.body

    // Organization Id not found
    if (_.isObject(response) && response.status === 404) {
      response = []
    }

    commit('setOrganizationLocations', response.data)
  },

  async getOrganizationView ({ commit, state, rootState }, payload) {
    let response = await org.getOrganization(payload.id)
    response = response.body
    if (_.isArray(response)) {
      response = response.pop()
    }
    response.programs = (response.programs || []).filter((p) => !p.isRemoved)
    commit('setViewOrganization', response)
  },

  async getOrganizationEdit ({ commit }, payload) {
    let response = await org.getOrganization(payload.id)
    response = response.body
    if (_.isArray(response)) {
      response = response.pop()
    }
    response.memberGroups = response.memberGroups.map((i) => i.id)
    if (!response.organizationTypes) {
      response.organizationTypes = []
    } else {
      response.organizationTypes = JSON.parse(response.organizationTypes)
    }
    response.programs = (response.programs || []).filter((p) => !p.isRemoved)
    commit('setEditOrganization', response)
  },

  async validateOrgName ({commit, state, rootState}, payload) {
    var response = await org.findByName(payload)
    return response.body
  },

  // Create
  async createOrganization ({commit, state, rootState}, payload) {
    commit('setCreateOrganizationPending', true)
    delete payload.id
    payload = mergeUserContext(payload, rootState)

    var response = await org.createOrganization(payload)
    commit('setCreateOrganizationPending', false)

    if (response.status !== 200) {
      console.log('error from org create API >>', response)
      if (response.body.details) {
        commit('setCreateOrganizationFailure', response.body.details)
      } else {
        commit('setCreateOrganizationFailure', this._vm.$utils.errorToHtml(response.body))
      }
      return
    }

    commit('setRecentlyCreatedOrganization', response.body)
    commit('addToOrganizationsList', response.body)
    commit('setCreateOrganization', Object.assign({}, OrganizationModel))

    return response.body
  },

  // update
  async updatedOrganization ({ commit, dispatch }, payload) {
    commit('setCreateOrganizationPending', true)
    var response = await org.updateOrganization(payload)
    commit('setCreateOrganizationPending', false)
    if (response.status !== 200) {
      console.log('error from org put API >>', response)
      if (response.body.details) {
        commit('setUpdateOrganizationFailure', response.body.details)
      } else {
        commit('setUpdateOrganizationFailure', this._vm.$utils.errorToHtml(response.body))
      }
      return
    }
    console.log('update org', response.body)
    commit('setUpdateOrganizationSuccess', response.body)

    const user = this._vm.$auth.user()
    dispatch('resetUser', user.id, { root: true })
  },

  async getOrganizationPrograms ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)

    let response = await org.getOrganizationPrograms(payload)

    // Organization Id not found
    if (_.isObject(response.body) && response.status === 404) {
      response = []
    }

    commit('setOrganizationPrograms', response.body.data)
  },

  async getLocationsByOrg ({ commit, state, rootState }, payload) {
    let response = await org.getLocationsByOrg(payload)

    // Organization Id not found
    if (_.isObject(response.body) && response.status === 404) {
      response = []
    }

    commit('setOrgLocations', response.body.data)
  },

  async getProgramsByOrg ({ commit, state, rootState }, payload) {
    let response = await org.getProgramsByOrg(payload)

    // Organization Id not found
    if (_.isObject(response.body) && response.status === 404) {
      response = []
    }

    console.log('response', response)

    commit('setOrgPrograms', response.body.data)
  },

  async getGroupsByOrg ({ commit, state, rootState }, payload) {
    let response = await org.findGroupMemberships(payload)
    // Organization Id no found
    if (_.isObject(response.body) && response.status === 404) {
      response = []
    }

    commit('setOrgGroups', response.data)
  }
  // #endregion
}

// mutations
const mutations = {

  resetCreateOrg (state) {
    state.createOrganization = Object.assign({}, OrganizationModel)
    state.createOrganization.organizationTypes = []
    state.createOrganizationPending = false
    state.createOrganizationFailure = false
    state.recentlyCreatedOrganization = false
  },

  resetEditOrg (state) {
    state.editOrganization = Object.assign({}, OrganizationModel)
    state.editOrganization.organizationTypes = []
    state.updateOrganizationPending = false
    state.updateOrganizationFailure = false
    state.updateOrganizationSuccess = false
  },

  resetOrgMembers (state) {
    state.orgMembers = []
  },

  resetOrgView (state) {
    state.ViewOrganization = Object.assign({}, OrganizationModel)
  },

  resetOrgUpdateMembership (state) {
    state.orgUpdateMemSuccess = false
    state.orgUpdateMemFailure = false
    state.orgUpdateMemPending = false
  },

  setOrgUpdateMemSuccess (state, record) {
    const existingIndex = state.orgMembers.findIndex((r) => r.id === record.id)
    if (existingIndex >= 0) {
      state.orgMembers.splice(existingIndex, 1, record)
    } else {
      console.log('did not find updated membership record in the membership list')
    }
    state.orgUpdateMemSuccess = record
  },

  setOrgDeleteMemSuccess (state, record) {
    const existingIndex = state.orgMembers.findIndex((r) => r.id === record.id)
    if (existingIndex >= 0) {
      state.orgMembers.splice(existingIndex, 1)
    } else {
      state.orgMembers.push(record)
    }
    state.orgUpdateMemSuccess = record
  },

  setOrgUpdateMemFailure (state, record) {
    state.orgUpdateMemFailure = record
    state.orgUpdateMemSuccess = false
  },

  setOrgUpdateMemPending (state, record) {
    state.orgUpdateMemPending = record
  },

  setOrgCreateMemSuccess (state, record) {
    state.orgCreateMemSuccess = record
    if (state.orgMembers && record) {
      state.orgMembers.push(record)
    }
  },

  setOrgCreateMemFailure (state, record) {
    state.orgCreateMemFailure = record
    state.orgCreateMemSuccess = false
  },

  setOrgCreateMemPending (state, record) {
    state.orgCreateMemPending = record
  },

  resetOrgCreateMembership (state) {
    state.orgCreateMemPending = false
    state.orgCreateMemSuccess = false
    state.orgCreateMemFailure = false
  },
  // #region Organization CRUD
  setUsersList (state, records) {
    state.allUserList = records
  },

  setUserLicenseAuth (state, records) {
    state.userLicenseAuth = records
  },

  setUserLicenseUsed (state, records) {
    state.userLicenseUsed = records
  },

  setOrgMember (state, record) {
    state.orgMembers = record
  },

  setUpdateOrganizationSuccess (state, record) {
    state.updateOrganizationSuccess = record
  },

  setUpdateOrganizationFailure (state, record) {
    state.updateOrganizationFailure = record
  },

  setCreateOrganizationFailure (state, record) {
    state.createOrganizationFailure = record
  },

  setCreateOrganizationPending (state, record) {
    state.createOrganizationPending = record
  },
  setAllOrganizations (state, records) {
    state.allOrganizations = records
  },

  setOrganizationLocations (state, records) {
    state.organizationLocations = records
  },
  setOrganizationPrograms (state, records) {
    state.organizationPrograms = records
  },
  setRecentlyCreatedOrganization (state, record) {
    state.recentlyCreatedOrganization = record
  },
  setShowCreatedModal (state, response) {
    state.showCreatedModal = response
  },
  setCreateOrganization (state, record) {
    state.createOrganization = record
    state.createOrganization.organizationTypes = record.organizationTypes
  },
  setEditOrganization (state, record) {
    state.editOrganization = record
    state.editOrganization.organizationTypes = record.organizationTypes
  },
  setViewOrganization (state, record) {
    if (_.isEmpty(record)) {
      state.ViewOrganization = Object.assign({}, OrganizationModel)
    } else {
      state.ViewOrganization = record
    }
  },
  addToOrganizationsList (state, newRecord) {
    var oldIndex = _.findIndex(state.allOrganizations, (r) => r._id === newRecord._id)
    if (oldIndex < 0) {
      state.allOrganizations.unshift(newRecord)
    } else {
      // Uh-oh - we tried to add a record that's already in our list
    }
  },

  setOrgLocations (state, records) {
    state.orgLocations = records
  },
  setOrgPrograms (state, records) {
    state.orgPrograms = records
  },
  setOrgGroups (state, records) {
    state.orgGroups = records
  },
  addToEditOrgTypes (state, record) {
    state.editOrganization.organizationTypes.push(record)
  },
  addToCreateOrgTypes (state, record) {
    state.createOrganization.organizationTypes.push(record)
  },
  removeFromEditOrgTypes (state, record) {
    state.editOrganization.organizationTypes.splice(record, 1)
  },
  removeFromCreateOrgTypes (state, record) {
    state.createOrganization.organizationTypes.splice(record, 1)
  }

  // #endregion
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/organization.js